import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import FacturacionTickets from './FacturacionTickets';

export class FacturacionRegistro extends Component {
  constructor() {
    super();
    this.state = {
      esFacturacionSingistro: false,
      urlBusquedaTickets: 'ticket/buscar_tickets.json',
      urlBusquedaReceptor: 'receptor/buscar_receptor_por_rfc.json',
      urlBusquedaUsosCfdi: 'usocfdi40/uso_cfdi_por_rfc.json',
      urlValidarTickets: 'ticket/validar.json',
      urlEliminarTickets: 'ticket/eliminar.json',
      urlGenerarFacturaTickets: 'ticket/facturar.json',
      urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
      urlObtenerElementosIne11: 'ine/obtener_elementos_ine11.json',
      urlActualizarFechaTicket:'ticket/actualizar_fecha.json',
      urlRegimenFiscal:'regimen/usocfdi_rfc.json',
      urlValidarReceptor40:'receptor/validar_receptor40.json'
    }
  }

  render() {

    const { esFacturacionSingistro, urlBusquedaTickets, urlBusquedaReceptor, urlBusquedaUsosCfdi,
      urlValidarTickets, urlEliminarTickets, urlGenerarFacturaTickets, urlDescargaArchivosFacturacion, urlObtenerElementosIne11, urlActualizarFechaTicket,urlRegimenFiscal,urlValidarReceptor40 } = this.state;

    return (
      <div className="p-fluid">
        <Growl ref={(el) => this.growl = el} />
        <div className="p-grid">
          <div className="p-col-12">
            <div className="card">
              <div className="p-grid">
                <div className="p-col-8"><h1>Facturación de Tickets de Peaje</h1></div>
              </div>
            </div>
          </div>
        </div>
        <FacturacionTickets esFacturacionSingistro={esFacturacionSingistro} urlBusquedaTickets={urlBusquedaTickets} urlBusquedaReceptor={urlBusquedaReceptor} urlBusquedaUsosCfdi={urlBusquedaUsosCfdi}
          urlValidarTickets={urlValidarTickets} urlEliminarTickets={urlEliminarTickets} urlGenerarFacturaTickets={urlGenerarFacturaTickets}
          urlDescargaArchivosFacturacion={urlDescargaArchivosFacturacion} urlObtenerElementosIne11={urlObtenerElementosIne11} urlActualizarFechaTicket={urlActualizarFechaTicket} urlRegimenFiscal={urlRegimenFiscal} urlValidarReceptor40={urlValidarReceptor40}/>
        
      </div>);
  }


}